import IcoMoon, { IconProps } from "react-icomoon";
import { iconSet } from "./selection";
import react from "react";

const Icon = (props: IconProps): react.ReactElement => (
  <IcoMoon
    iconSet={iconSet}
    {...props}
  />
);

export default Icon;
